import PMBTabSwitcher from 'components/PMBTabSwitcher'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  URL_FARMERS,
  URL_FARMERS_GROUPS,
  URL_FARMERS_SHARED,
} from 'utils/pathUrl'
const tabManageStaff = [
  {
    id: 1,
    label: 'Anggota',
    page: URL_FARMERS,
    key: URL_FARMERS,
  },
  {
    id: 2,
    label: 'Grup',
    page: URL_FARMERS_GROUPS,
    key: URL_FARMERS_GROUPS,
  },
  {
    id: 3,
    label: 'Daftar Anggota Bersama',
    page: URL_FARMERS_SHARED,
    key: URL_FARMERS_SHARED,
  },
]

export default function TabManageStaffGroup() {
  const navigate = useNavigate()
  let location = useLocation()

  const handleTabChange = (tabKey) => {
    navigate(tabKey)
  }

  return (
    <PMBTabSwitcher
      activeTab={location?.pathname}
      tabs={tabManageStaff}
      onTabChange={handleTabChange}
      testId="farmer-tab-switcher"
      variant="pills"
    />
  )
}
